export function normalizeTerminalSymbol(raw: string) {
  const text = String(raw || "").trim().toUpperCase();
  if (!text) {
    return "";
  }
  const tsCodeMatch = text.match(/^(\d{6})\.(SH|SZ)$/);
  if (tsCodeMatch) {
    return `${tsCodeMatch[1]}.${tsCodeMatch[2]}`;
  }
  const prefixedMatch = text.match(/^(SH|SZ)(\d{6})$/);
  if (prefixedMatch) {
    return `${prefixedMatch[2]}.${prefixedMatch[1]}`;
  }
  const codeOnlyMatch = text.match(/^(\d{6})$/);
  if (codeOnlyMatch) {
    const code = codeOnlyMatch[1];
    const suffix = code.startsWith("6") || code.startsWith("5") || code.startsWith("9") ? "SH" : "SZ";
    return `${code}.${suffix}`;
  }
  return text;
}
